// extracted by mini-css-extract-plugin
export var totals = "CartTotal-module--totals---zm80";
export var totalsInner = "CartTotal-module--totalsInner--OLn-N";
export var subTotal = "CartTotal-module--subTotal--23aNg";
export var total = "CartTotal-module--total--5KoH0";
export var checkout = "CartTotal-module--checkout--WueH3";
export var disclaimer = "CartTotal-module--disclaimer--0PfYn";